const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class DefensiveArmy extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.DefensiveArmy,
            [2, 0, 1],
            "6(3)",
            {}
        )
    }
}

module.exports = DefensiveArmy;